import { FC, ReactElement, useState } from 'react'
import { useToggle } from 'react-use'

import { ModalContent, PacoModal } from '../../compositions'
import {
    ConnectedAddChangeLogEntryForm,
    ConnectedDeleteChangeLogEntryForm,
    ConnectedEditChangeLogEntryForm,
} from '../../connectors'
import { ChangeLogEntry } from '../../entities/ChangeLog/ChangeLog'
import trans from '../../helpers/trans'
import { ChangeLogEntriesTable } from '../index'

interface ChangeLogEntriesContainerProps {
    isLoading?: boolean
    changeLogEntries: ChangeLogEntry[]
}

export const ChangeLogEntriesContainer: FC<ChangeLogEntriesContainerProps> = ({
    isLoading,
    changeLogEntries,
}): ReactElement => {
    const [addChangeLogEntryModalIsOpen, toggleAddChangeLogEntryModalIsOpen] = useToggle(false)
    const [editChangeLogEntryModalIsOpen, toggleEditChangeLogEntryModalIsOpen] = useToggle(false)
    const [deleteChangeLogEntryModalIsOpen, toggleDeleteChangeLogEntryModalIsOpen] = useToggle(false)
    const [changeLogEntryState, setChangeLogEntryState] = useState<ChangeLogEntry | undefined>(undefined)
    const [changeLogEntryIdState, setChangeLogEntryIdState] = useState<string | undefined>(undefined)

    const handleEditChangeLogEntryClick = (changeLogEntry: ChangeLogEntry): void => {
        toggleEditChangeLogEntryModalIsOpen()
        setChangeLogEntryState(changeLogEntry)
    }

    const handleDeleteChangeLogEntryClick = (changeLogEntryId: string): void => {
        toggleDeleteChangeLogEntryModalIsOpen()
        setChangeLogEntryIdState(changeLogEntryId)
    }

    return (
        <>
            <ChangeLogEntriesTable
                isLoading={isLoading}
                changeLogEntries={changeLogEntries}
                onAddChangeLogEntryClick={toggleAddChangeLogEntryModalIsOpen}
                onEditChangeLogEntryClick={handleEditChangeLogEntryClick}
                onDeleteChangeLogEntryClick={handleDeleteChangeLogEntryClick}
            />

            {addChangeLogEntryModalIsOpen && (
                <PacoModal onClose={() => toggleAddChangeLogEntryModalIsOpen(false)}>
                    <ModalContent title={trans('common.addChangeLogEntry')}>
                        <ConnectedAddChangeLogEntryForm onClose={toggleAddChangeLogEntryModalIsOpen} />
                    </ModalContent>
                </PacoModal>
            )}

            {editChangeLogEntryModalIsOpen && changeLogEntryState && (
                <PacoModal onClose={() => toggleEditChangeLogEntryModalIsOpen(false)}>
                    <ModalContent title={trans('common.editChangeLogEntry')}>
                        <ConnectedEditChangeLogEntryForm
                            changeLogEntry={changeLogEntryState}
                            onClose={toggleEditChangeLogEntryModalIsOpen}
                        />
                    </ModalContent>
                </PacoModal>
            )}

            {deleteChangeLogEntryModalIsOpen && changeLogEntryIdState && (
                <PacoModal onClose={() => toggleDeleteChangeLogEntryModalIsOpen(false)}>
                    <ModalContent title={trans('common.deleteChangeLogEntry')}>
                        <ConnectedDeleteChangeLogEntryForm
                            changeLogEntryId={changeLogEntryIdState}
                            onClose={toggleDeleteChangeLogEntryModalIsOpen}
                        />
                    </ModalContent>
                </PacoModal>
            )}
        </>
    )
}
